import { render } from "./LockExtensionsDashboard.vue?vue&type=template&id=6acf8fad&scoped=true"
import script from "./LockExtensionsDashboard.vue?vue&type=script&lang=js"
export * from "./LockExtensionsDashboard.vue?vue&type=script&lang=js"

import "./LockExtensionsDashboard.vue?vue&type=style&index=0&id=6acf8fad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6acf8fad"]])

export default __exports__